module.exports = __webpack_public_path__ + "static/img/title-env.e692fc80.png";